import { useTranslation } from "react-i18next";

import { ERROR_CODES } from "./constants";
import { renderErrorMessage } from "./utils";

const ErrorMessages = ({ fileRejections, maxFileSizeInBytes }) => {
  const { t } = useTranslation();

  const hasMultipleFileErrors = fileRejections.some(
    ({ errors }) => errors[0].code === ERROR_CODES.TOO_MANY_FILES
  );

  return (
    <>
      {hasMultipleFileErrors && (
        <p
          className="neeto-molecules-input__error-text"
          data-testid="form-file-upload-input-error"
        >
          <span className="neeto-molecules-input__error-text-style-handle">
            {t("neetoMolecules.fileUpload.filesDropzone.errors.tooManyFiles", {
              maxFiles: 1,
            })}
          </span>
        </p>
      )}
      {fileRejections
        .filter(({ errors }) => errors[0].code !== ERROR_CODES.TOO_MANY_FILES)
        .map((file, index) => (
          <p
            className="neeto-molecules-input__error-text"
            data-testid="form-file-upload-input-error"
            key={index}
          >
            <span className="neeto-molecules-input__error-text-style-handle">
              {renderErrorMessage(file, maxFileSizeInBytes, false)}
            </span>
          </p>
        ))}
    </>
  );
};

export default ErrorMessages;
